import { DebugLogger, Logger } from "@ng-mw/shared-react-components"
import { userActions, bonusCampaignActions } from "@ng-mw/shared-react-components/user"
import { cardsActions, profileInfoActions } from "@ng-mw/shared-react-components/ngc-my-page"
import { bonusActions } from "@ng-mw/shared-react-components/use-bonus"
import { couponsActions } from "@ng-mw/shared-react-components/coupons"
import { transactionHistoryActions } from "@ng-mw/shared-react-components/transaction-history"
import { getSavings } from "@ng-mw/shared-react-components/src/modules/savings/store/actions/savingsActions"
import {
    getAllFavoriteRecipes,
    unloadFavoriteRecipes,
} from "@modules/recipes/shared-recipes/store/actions/favoriteRecipesActions"

import { consentsActions } from "@ng-mw/shared-react-components/consents"
import { ordersActions } from "@ng-mw/shared-react-components/orders"
import { insightActions } from "@ng-mw/shared-react-components/insight"
import { AnyAction, Dispatch } from "redux"
import AppGlobalSettings from "@app/AppGlobalSettings"
import { RootState } from "@app/types"
import { qrClear } from "./creators/qrCreator"
import { deleteUserServiceWorkerCache } from "@modules/user/helpers/deleteUserServiceWorkerCache"

export const loadAuthedBaseData = () => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
        const state = getState()
        const userIsCorporate = state.user.data.household.isOrganization
        const userIsLoggedIn = state.user.loginLevel > 0

        const transactionHistory = state.transactionHistory.history
        const savings = state.savings

        dispatch(getAllFavoriteRecipes())
        dispatch(userActions.checkIfDeliveryIsPossible())

        if (!userIsCorporate) {
            dispatch(bonusActions.getBonusData())
            dispatch(bonusCampaignActions.getRelevantBonuses())
            dispatch(couponsActions.getAllCoupons())
            dispatch(
                consentsActions.fetchConsentsAndAgreements([
                    {
                        id: AppGlobalSettings.loyaltyClubAgreementId,
                    },
                ]),
            )
        }

        if (!userIsLoggedIn) {
            return
        }
        const extraPreload = () => {
            if (userIsCorporate) {
                return
            }

            DebugLogger.log("Load-order-debug: preloading API's now!")
            // Preload transactions
            if (!transactionHistory.isLoading && !transactionHistory.transactions) {
                dispatch(transactionHistoryActions.getTransactionHistory())
            }
            // Preload savings
            if (!savings.isLoading && !savings.loaded) {
                dispatch(getSavings("MENY"))
            }
        }

        if (AppGlobalSettings.aggressivePreload) {
            extraPreload()
        } else {
            setTimeout(extraPreload, 7000) // delay preloading for 7 seconds
        }

        DebugLogger.log("Load-order-debug: loadAuthedBaseData!")
    }
}

export const loadBaseData = () => {
    return () => {
        DebugLogger.log("Load-order-debug: loadBaseData!")
    }
}

export const resetAuthedBaseData = () => {
    return async (dispatch: Dispatch) => {
        await Promise.all([
            dispatch(bonusActions.resetBonusData()),
            dispatch(profileInfoActions.resetMemberInformation()),
            dispatch(transactionHistoryActions.resetTransactionHistory() as unknown as AnyAction),
            // dispatch(resetSavings() as unknown as AnyAction), // TODO is this needed?
            dispatch(unloadFavoriteRecipes() as unknown as AnyAction),
            dispatch(cardsActions.resetCardInformation()),
            dispatch(insightActions.resetAllDietData()),
            dispatch(consentsActions.resetConsents()),
            dispatch(qrClear()),
            dispatch(ordersActions.clear()),
            deleteUserServiceWorkerCache(),
            // dispatch(clearRelevantBonuses()), // todo do we need this?
        ])
    }
}

export const setToken = (token = "", isInitialLogin = false) => {
    return async (dispatch: Dispatch<any>) => {
        try {
            if (token) {
                await dispatch(userActions.setToken(token, isInitialLogin))
                await dispatch(loadAuthedBaseData() as unknown as AnyAction)
            } else {
                dispatch(userActions.logOut())
            }
        } catch (e) {
            Logger.error("modules/user/actions/setToken()", e, {
                hasToken: !!token,
                isInitialLogin,
            })
        }
    }
}

export const initAnonymousUser = () => {
    return async (dispatch: Dispatch<any>) => {
        await dispatch(getExtendedUser())
    }
}

export const updateToken = (token: string) => {
    return async (dispatch: Dispatch<any>) => {
        try {
            if (token) {
                await dispatch(userActions.updateToken(token))
            } else {
                dispatch(userActions.logOut())
            }
        } catch (e) {
            Logger.error("modules/user/actions/updateToken()", e, {
                hasToken: !!token,
            })
        }
    }
}

export const {
    ChangeTrigger,
    checkIfDeliveryIsPossible,
    updateTrumfProfile,
    updateAlternativeAddress,
    deleteAlternativeAddress,
    logOut,
    logIn,
    clearError,
    extendedUserHasChanged,
    saveExtendedUserHousehold,
    setHandoverInfoAndStore,
    setHandoverTypeAndLocation,
    setHandoverWindow,
    updateHandoverWindowData,
    resetHandoverWindow,
    getExtendedUser,
} = userActions
